import React from "react";
import {
    Form,
    FormElement,
    FormValidator,
    BaseReactComponent,
    SelectControl,
} from "../../utils/form";
import { Row, Col } from "react-bootstrap";
import { isModuleExist, MODULE_ID_MAP, } from "../../utils/Constant";
import { postAuthCommonApi, putAuthCommonApi } from "../content/Api";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { ComponentHeader } from "../common";
import ReactDOM from "react-dom";
import { getAllSsoPartnersApi } from "../sso/Api";
import { isPartnerAllowed } from "../../utils/ReusableFunctions";
import { withRouter } from './../../utils/hoc/withRouter';
import { toast } from "react-toastify";
import RepeatSvg from "../../assets/images/repeat.svg"
import moment from "moment";

class InvoiceForm extends BaseReactComponent {
    constructor(props) {
        super(props);

        const invoice = props.location.state?.editData || {};
        console.log(invoice)

        const AccesData = isModuleExist(MODULE_ID_MAP.SubscriptionInvoice);

        let partners = this.loadDefaultPartners(AccesData)
        if (invoice?.partners?.list) {
            partners = invoice?.partners
        }
        this.state = {
            AccessData: AccesData,
            partners,
            editData: invoice,
            invoice: {
                userId: invoice?.userId,
                // billingUuid:invoice.billingUuid,
                invoiceDate: moment(invoice.invoiceDate)?.format("yyyy-MM-DD") || "",
                billAmount: invoice.billAmount || "",
                companyName: invoice.companyName || "",
                companyAddress: invoice.companyAddress || "",
                emailAddress: invoice.emailAddress || "",
                gstNumber: invoice.gstNumber || "",
                // ensure new entries include isPercentage flag (defaults false)
                subDescriptions: invoice.subDescriptions || [
                    { description: "", amount: 0, isTax: false, isDiscount: false, isPercentage: false, uuid: crypto.randomUUID() }
                ]
            }
        };
    }

    componentDidMount() {
        getAllSsoPartnersApi(this)
    }

    componentDidUpdate(prevProps, prevState) {

    }

    handleChange = (key, value) => {
        this.setState(prev => ({
            invoice: {
                ...prev.invoice,
                [key]: value
            }
        }));
    };

    handleDescriptionChange = (uuid, values) => {
        this.setState(prev => ({
            invoice: {
                ...prev.invoice,
                subDescriptions: prev.invoice.subDescriptions.map(item =>
                    item.uuid === uuid ? { ...item, ...values } : item
                )
            }
        }))
    }

    handleAddDescription = (uuid, values) => {
        this.setState(prev => ({
            invoice: {
                ...prev.invoice,
                subDescriptions: [
                    ...prev.invoice.subDescriptions,
                    { uuid, isPercentage: false, ...values }
                ]
            }
        }))
    }

    handleRemoveDescription = (uuid) => {
        this.setState(prev => ({
            invoice: {
                ...prev.invoice,
                subDescriptions: prev.invoice.subDescriptions.filter(
                    item => item.uuid !== uuid
                )
            }
        }))
    }

    /**
     * Calculation logic:
     * - subtotal = sum of all items where isTax === false
     * - bottom adjustments = for each item where isTax === true:
     *     if isPercentage === true -> adj = (item.amount / 100) * subtotal
     *     else -> adj = Number(item.amount)
     *   if isDiscount === true -> adj is subtracted (negative), otherwise added
     * - total = subtotal + sum(adjustments)
     */
    calculateDescriptionAmount = () => {
        const subs = this.state.invoice.subDescriptions || [];

        // 1) base: sum of normal items (not discounts, not taxes)
        const base = subs.reduce((acc, item) => {
            if (item.isDiscount || item.isTax) return acc;
            return acc + Number(item.amount || 0);
        }, 0);

        // 2) total discount amount (flat or percentage of base)
        const discountAmount = subs.reduce((acc, item) => {
            if (!item.isDiscount) return acc;
            const raw = Number(item.amount || 0);
            const adj = item.isPercentage ? (raw / 100) * base : raw;
            return acc + adj;
        }, 0);
        console.log({ subs, base, discountAmount });

        // 3) subtotal after discounts (this is what taxes should apply to)
        const subtotal = base - discountAmount;

        const taxAmount = subs.reduce((acc, item) => {
            if (!item.isTax || item.isDiscount) return acc;
            const raw = Number(item.amount || 0);
            const adj = item.isPercentage ? (raw / 100) * subtotal : raw;
            return acc + adj;
        }, 0);
        console.log({ taxAmount });

        // 5) final total
        const total = subtotal + taxAmount;

        // round to 2 decimals
        return Math.round((total + Number.EPSILON) * 100) / 100;
    }
    getAmountAfterDiscount = () => {
        const subs = this.state.invoice.subDescriptions || [];

        const base = subs.reduce((acc, item) => {
            if (item.isDiscount || item.isTax) return acc;
            return acc + Number(item.amount || 0);
        }, 0);

        const discountAmount = subs.reduce((acc, item) => {
            if (!item.isDiscount) return acc;
            const raw = Number(item.amount || 0);
            const adj = item.isPercentage ? (raw / 100) * base : raw;
            return acc + adj;
        }, 0);

        const subtotal = base - discountAmount;

        return Math.round((subtotal + Number.EPSILON) * 100) / 100;
    };


    getDescriptionByUuid = (uuid) => {
        return this.state.invoice.subDescriptions?.find(item => item.uuid === uuid) || {}
    }

    // *================ SUBMIT HANDLER ======================
    onValidSubmit = async () => {
        this.setState({ resLoading: true });

        const { invoice } = this.state

        if (this.calculateDescriptionAmount() <= 0) {
            toast.info("Invoice Amount is required -- Add descriptions")
            this.setState({ resLoading: false })
            return
        }

        if (!invoice.invoiceDate) {
            this.setState({ resLoading: false })
            return toast.info("Invoice Date is Mandatory")
        }

        const getFinalAmount = (item, invoice) => {
            if (!item.isPercentage) {
                return item.amount
            }
            if (item.isTax && !item.isDiscount) {
                const amountAfterDiscount = this.getAmountAfterDiscount() 
                const finalAmount = (Number(item.amount || 0) / 100) * amountAfterDiscount
                return finalAmount
            }
            if (item.isDiscount) {
                const discountValue = (Number(item.amount || 0) / 100) * invoice.subDescriptions.reduce((acc, i) => {
                    if (i.isDiscount || i.isTax) return acc;
                    return acc + Number(i.amount || 0);
                }
                    , 0)
                return discountValue
            }
        }

        const postData = {
            "data": {
                ...invoice,
                billAmount: Number(this.calculateDescriptionAmount()),
                userId: Number(invoice.userId),
                invoiceDate: invoice.invoiceDate,
                subDescriptions: invoice?.subDescriptions?.map(item => ({
                    description: item.description, amount: item.amount, isTax: item.isTax, isDiscount: item.isDiscount, isPercentage: item.isPercentage,
                    finalAmount: getFinalAmount(item, invoice)
                })) || []
            }
        }
        if (this.state.editData?.uuid) {
            const response = await putAuthCommonApi(`invoice/${this.state.editData?.uuid}`, postData);
            if (response.status < 250 && response.status > 199) {
                // toast.success("Successfully Updated.")
                this.setState({ resLoading: false });
                this.props.history({ pathname: `/invoice` });
            } else {
                this.setState({ resLoading: false });
            }

        } else {
            const response = await postAuthCommonApi('/invoice', postData);
            // console.log(response);
            if (response.status < 250 && response.status > 199) {
                this.setState({ resLoading: false });
                this.props.history({ pathname: `/invoice` });
                // toast.success("Successfully saved.")
            }
            else {
                // toast.success("Errer is get sucess in Post ai")
                this.setState({ resLoading: false });
            }

        }
    }
    handleSave = () => {
        ReactDOM.findDOMNode(this.form).dispatchEvent(
            new Event("submit", { cancelable: true, bubbles: true })
        );
    };
    render() {

        const { editData, invoice } = this.state
        const topDescriptions = invoice.subDescriptions?.filter(i => !i.isTax)
        const bottomDescriptions = invoice.subDescriptions?.filter(i => i.isTax)
        return (
            <section className="add-section">
                <ComponentHeader
                    // title={this.state.editData?.uuid ? "Edit Plan" : "Add Plan"}
                    title={editData?.uuid ? "Edit Invoice" : " Add Invoice"}
                    primaryBtn="Save"
                    isSearch={false}
                    isBackArrow={true}
                    resLoading={this.state.resLoading}
                    isReturn="/Invoice"
                    handlePrimaryBtn={() => { this.handleSave() }}
                // handlePrimaryBtn={() => { this.props.history('/add-content') }}
                />
                <Form ref={(el) => (this.form = el)} onValidSubmit={this.onValidSubmit}>
                    {/* <Row>
                        {isPartnerAllowed(this.state.AccessData?.id) &&
                            <Col md={4}>
                                <FormElement
                                    valueLink={this.linkState(this, "partners.list")}
                                    label="Publish To Partner(s)"
                                    required
                                    validations={[
                                        {
                                            validate: FormValidator.isRequired,
                                            message: "Publish To cannot be empty",
                                        },
                                    ]}
                                    control={{
                                        type: SelectControl,
                                        settings: {
                                            options: this.state?.ssoPartnersOptions || [],
                                            placeholder: "Select Partner(s)",
                                            multiple: true,
                                            searchable: true,
                                            selectAll: true,
                                            onChangeCallback: (onBlur) => {
                                            },
                                        },
                                    }}
                                />

                            </Col>}
                    </Row> */}

                    <div className="invoice-form-wrapper">
                        <div className="invoice-wrapper">
                            <table className="w-100">
                                <tbody>
                                    {/* Header */}
                                    <tr>
                                        <td className="w-50">
                                            <img
                                                src="https://s3.ap-south-1.amazonaws.com/beta.thefinpedia.com/category/thumbnail/84f24da5-4abc-482d-a88f-9d0ba160be0e_.jpg"
                                                alt="logo"
                                                width={190}
                                            />
                                        </td>
                                        <td className="w-50 text-end">
                                            <h2 className="f-s-38 inter-bold">INVOICE</h2>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="mt-5">
                                            &nbsp;
                                        </td>
                                    </tr>

                                    {/* Company + Meta */}
                                    <tr >
                                        <td>
                                            <ul className="addrace-list">
                                                <li className="mb-0">Khayalipulav Infomedia LLP</li>
                                                <li className="mb-0">7th Floor, Merchant Chambers</li>
                                                <li className="mb-0"> Vitthaldas Thackersey Marg,</li>
                                                <li className="mb-0">New Marine Lines,Churchgate</li>
                                                <li className="mb-0">Mumbai, Maharashtra</li>
                                                <li className="mb-0">400020</li>
                                                <li className="mb-0">HSN / SAC Code <span className="bold">9983</span></li>
                                                <li>
                                                    GSTIN <span className="bold">27ABBFK7597C1Z3</span>
                                                </li>
                                            </ul>
                                        </td>

                                        <td>
                                            <ul className="invoce-top-right">
                                                <li />
                                                <li>
                                                    Invoice Date*
                                                    <input
                                                        type="date"
                                                        value={invoice.invoiceDate}
                                                        className="ml-3"
                                                        onChange={e =>
                                                            this.handleChange("invoiceDate", e.target.value)
                                                        }
                                                    />
                                                </li>

                                                <li>
                                                    Customer ID
                                                    <input
                                                        type="number"
                                                        onWheel={(e) => e.target.blur()}
                                                        value={invoice.userId}
                                                        className="ml-3"
                                                        onChange={e =>
                                                            this.handleChange("userId", e.target.value)
                                                        }
                                                    />
                                                </li>

                                                <li className="primary inter-bold">PAID</li>
                                            </ul>
                                        </td>
                                    </tr>

                                    {/* Billed To */}
                                    <tr>
                                        <td>
                                            <ul className="addrace-list">
                                                <li className="bold mt-2">BILLED TO</li>

                                                <li>
                                                    <input
                                                        placeholder="Company Name"
                                                        value={invoice.companyName}
                                                        onChange={e =>
                                                            this.handleChange("companyName", e.target.value)
                                                        }
                                                    />
                                                </li>

                                                <li>
                                                    <textarea
                                                        rows={2}
                                                        placeholder="Company Address"
                                                        value={invoice.companyAddress}
                                                        onChange={e =>
                                                            this.handleChange("companyAddress", e.target.value)
                                                        }
                                                    />
                                                </li>

                                                <li>
                                                    <input
                                                        type="emailAddress"
                                                        placeholder="Email"
                                                        value={invoice.emailAddress}
                                                        onChange={e =>
                                                            this.handleChange("emailAddress", e.target.value)
                                                        }
                                                    />
                                                </li>

                                                <li>
                                                    GSTIN
                                                    <input
                                                        className="ml-3"
                                                        value={invoice.gstNumber}
                                                        onChange={e =>
                                                            this.handleChange("gstNumber", e.target.value)
                                                        }
                                                    />
                                                </li>
                                            </ul>
                                        </td>

                                        {/* Subscription */}
                                        <td>
                                        </td>
                                    </tr>

                                    {/* Description */}
                                    <tr>
                                        <td colSpan="2">
                                            <div className="description">
                                                <span>DESCRIPTION</span>
                                                <span className="bold">AMOUNT (INR)</span>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td colSpan="2">

                                            <div className="premium-montly bold d-flex flex-column gap-12">
                                                {
                                                    topDescriptions?.length > 0 && topDescriptions?.map(({ description, amount, uuid }) => {
                                                        return <div className="d-flex gap-12" key={uuid}>

                                                            <input
                                                                type="text"
                                                                placeholder="Description"
                                                                className="flex-grow-1"
                                                                value={this.getDescriptionByUuid(uuid).description}
                                                                onChange={e => {
                                                                    this.handleDescriptionChange(uuid, { description: e.target.value })
                                                                }}
                                                            />
                                                            <input
                                                                type="number"
                                                                onWheel={(e) => e.target.blur()}
                                                                placeholder="Amount*"
                                                                required
                                                                className="flex-grow-1"
                                                                style={{ maxWidth: "20rem" }}
                                                                value={this.getDescriptionByUuid(uuid).amount}
                                                                onChange={e => {
                                                                    this.handleDescriptionChange(uuid, { amount: e.target.value })
                                                                }}
                                                            />

                                                            {invoice.subDescriptions?.length > 1 && <div
                                                                className="cursor-pointer pointer"
                                                                onClick={() => {
                                                                    this.handleRemoveDescription(uuid)
                                                                }}
                                                            >❌</div>}
                                                        </div>
                                                    })
                                                }
                                                <div className="d-flex gap-12">
                                                    <button
                                                        type="button"
                                                        className="primary-btn white mt-2 py-2 pointer"
                                                        onClick={() => {
                                                            this.handleAddDescription(crypto.randomUUID(), { description: "", amount: 0, isTax: false, isDiscount: false, isPercentage: false })
                                                        }}
                                                    >Add Description</button>
                                                    <button
                                                        type="button"
                                                        className="primary-btn white mt-2 py-2 pointer"
                                                        onClick={() => {
                                                            this.handleAddDescription(crypto.randomUUID(), { description: "", amount: 0, isTax: true, isDiscount: false, isPercentage: false })
                                                        }}
                                                    >Add Tax</button>
                                                    <button
                                                        type="button"
                                                        className="primary-btn white mt-2 py-2 pointer"
                                                        onClick={() => {
                                                            this.handleAddDescription(crypto.randomUUID(), { description: "", amount: 0, isTax: true, isDiscount: true, isPercentage: false })
                                                        }}
                                                    >Add Discounts</button>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-end mt-4">
                                                <div className="w-50 d-flex flex-column gap-12">
                                                    {
                                                        bottomDescriptions?.length > 0 && bottomDescriptions?.map(({ description, amount, uuid, isDiscount, isPercentage }) => {
                                                            return <div className="d-flex gap-12" key={uuid}>
                                                                {/* discount toggle (existing) */}



                                                                <input
                                                                    type="text"
                                                                    placeholder={`${isDiscount ? "Discount" : "Tax"} Description`}
                                                                    className="flex-grow-1"
                                                                    value={this.getDescriptionByUuid(uuid).description}
                                                                    onChange={e => {
                                                                        this.handleDescriptionChange(uuid, { description: e.target.value })
                                                                    }}
                                                                />
                                                                <div className="adv-input d-flex">
                                                                    <button
                                                                        type="button"
                                                                        className="pointer percent-toggle-btn f-s-20"
                                                                        onClick={() => {
                                                                            this.handleDescriptionChange(uuid, { isDiscount: !isDiscount })
                                                                        }}
                                                                    >
                                                                        {isDiscount ? "-" : "+"}
                                                                    </button>
                                                                    <input
                                                                        type="number"
                                                                        onWheel={(e) => e.target.blur()}
                                                                        placeholder={isPercentage ? "Percent (e.g. 18)" : "Amount*"}
                                                                        required
                                                                        className="flex-grow-1"
                                                                        style={{ maxWidth: "8rem" }}
                                                                        value={this.getDescriptionByUuid(uuid).amount}
                                                                        onChange={e => {
                                                                            this.handleDescriptionChange(uuid, { amount: e.target.value })
                                                                        }}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        title={isPercentage ? "Percentage mode" : "Fixed amount mode"}
                                                                        className="pointer percent-toggle-btn f-s-20"
                                                                        onClick={() => {
                                                                            this.handleDescriptionChange(uuid, { isPercentage: !isPercentage })
                                                                        }}
                                                                    >
                                                                        {isPercentage ? "%" : "₹"}
                                                                    </button>
                                                                </div>

                                                                {invoice.subDescriptions?.length > 1 && <div
                                                                    className="cursor-pointer pointer"
                                                                    onClick={() => {
                                                                        this.handleRemoveDescription(uuid)
                                                                    }}
                                                                >❌</div>}
                                                            </div>
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </td>
                                    </tr>

                                    {/* Total */}
                                    <tr>
                                        <td colSpan="2" className="underline">
                                            <strong className="primary f-s-22 d-flex justify-content-end">
                                                Total ₹{" "}
                                                {this.calculateDescriptionAmount()}
                                            </strong>
                                        </td>
                                    </tr>

                                    {/* Footer */}
                                    <tr>
                                        <td colSpan="2">
                                            <div className="footer-text">
                                                <h3 className="primary">
                                                    Thank you for trusting us
                                                </h3>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </Form>
            </section>
        );
    }
}

export default withRouter(InvoiceForm);
